export const assertNever = (value: never) => value;
